<div class="layout-footer flex items-center justify-between px-3 text-xs">
    <span>
        Powered by
        <a href="" target="_blank" rel="noopener noreferrer" class="text-primary font-bold hover:underline">ERPA</a>
    </span>
    <span class="text-gray-500">
        v{{ versionSvc.version() }}

        @if (updater.ready()) {
            <a class="ml-2 text-green-600 cursor-pointer hover:underline" (click)="onInstall()">
                · Restart to apply v{{ updater.latestVersion() }}
            </a>
        } @else if (updater.downloading()) {
            <span class="ml-2 text-blue-500">· Downloading {{ updater.progressPercent() }}%</span>
        } @else if (updater.available()) {
            <a class="ml-2 text-blue-500 cursor-pointer hover:underline" (click)="onDownload()">
                · Update to v{{ updater.latestVersion() }}
            </a>
        }
    </span>
</div>
